/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

	$('.wf-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		infinite: true,
		dots: true,
		fade: true,
		autoplay: true,
		autoplaySpeed: 7000,
	});

});
